<template>
    <div class="plan-admin mb-3 mt-page">

        <crud-table :title="pageTitle"
                    item-table="plan"
                    :item-name="$i18n.gt('LABEL_PLAN')"
                    :new-item="newItem"
                    :filters="filters"
                    :show-details="true"
                    :display-fields="displayFields"
                    :edit-fields="editFields">

            <template v-slot:customRowDetails="slotProps">
                <div class="float-right ml-3">
                    <router-link class="btn btn-primary"
                                 :to="resourcesRoute(slotProps.row.item.id)">
                        {{ $i18n.gt('LABEL_PLAN_RESOURCES') }}
                    </router-link>
<!--                    <router-link class="btn btn-primary ml-3"-->
<!--                                 :to="`/plan/aggregateReport/companyId/${slotProps.row.item.company_id}/id/${slotProps.row.item.id}`">-->
<!--                        {{ $i18n.gt('LABEL_QUESTION_STATISTICS') }}-->
<!--                    </router-link>-->
                    <!--
                    <router-link class="btn btn-primary ml-3"
                       :to="`/plan/usageReport/id/${slotProps.row.item.id}`">
                        Usage Report
                    </router-link>
                    -->
                </div>
            </template>

        </crud-table>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'

/**
 * Page for admin to manage Plans
 */
export default Vue.extend({
    name: 'PlanAdmin',
    props: {
        companyId: Number,
        resellerId: Number,
    },
    data() {
        return {
            company: {},
            displayFields: [
                {key: 'name', sortable: true},
            ],
        }
    },
    computed: {
        pageTitle() {
            return this.$i18n.gt('HEADING_MANAGE_PLANS_FOR') + ' ' + (this.company.name ? this.company.name : 'Company')
        },
        newItem() {
            return {
                name: '',
                company_id: this.companyId,
            }
        },
        filters() {
            return {
                company_id: {field: 'company_id', type: 'hidden', value: this.companyId},
                name: {
                    field: 'name',
                    type: 'string',
                    value: null,
                    label: 'Name'
                },
            }
        },
        editFields() {
            return [
                {key: 'name', type: 'text', label: 'Name'},
            ]
        },
    },
    methods: {
        resourcesRoute(planId) {
            if (this.$user.roleIs('PRACTITIONER') && this.$auth.canManageCompanyPlans()) {
                return `/companyPractitioner/planResources/companyId/${this.companyId}/planId/${planId}`
            } else if (this.$user.roleIsCompanyAdmin()) {
                return `/companyAdmin/planResources/companyId/${this.companyId}/planId/${planId}`
            } else {
                return `/company/planResources/companyId/${this.companyId}/planId/${planId}`
            }
        },
    },
    mounted() {
        this.$api.getItem(this, 'company', this.companyId)
            .then((item) => {
                this.company = item
            })
    }
})

</script>
